import React, { Component } from "react";
import { formBuilderGroups } from "../../../variables/formBuilderData";
import Collapsible from "react-collapsible";
import { checkTranslation, translate } from "../../../utils/useful";

class ExistingQuestion extends Component {
    state = {
        // closedGroups: {},
        // showChildsSide: false
    };

    onDragStart = (e, rowId, type) => {
        let dataObject = { rowId, type, dropType: "NEW" };
        if (e.dataTransfer.setData) {
            e.dataTransfer.setData(
                "dragData",
                JSON.stringify(dataObject)
            );
        } else {
            e.dataTransfer.rowId = rowId;
            e.dataTransfer.type = type;
        }
        this.props.showhandlers();
    };


    // toggleOpen = (key) => {
    //     let closedGroups = this.state.closedGroups
    //     closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
    //     this.setState({ closedGroups })
    // }

    render() {
        const { formItems, hideHandlers } = this.props;

        return (
            <div className="h-100 pt-3 pb-3">
                {Object.values(formBuilderGroups).map((group, index) => {
                    if (group.key == 'main') {
                        return (
                            <div className=" p-2 w-100 h-100" style={{}} key={group.key}>
                                <div className="d-flex " style={{ flexWrap: 'wrap', alignItems: "stretch" }}>
                                    {formItems.map((formItem, index) => {
                                        if (this.props?.page) {
                                            if (formItem?.used?.includes(this.props.page)) {
                                                if (formItem.parent === group.key)
                                                    return (
                                                        <div className=" p-1 mb-0" style={{ width: '50%' }} key={formItem.type}>
                                                            <div key={index} className="form-item flexcc flex-column text-smaller pt-2 pb-2" onDragStart={(e) => this.onDragStart(e, index, formItem.type)} onDragEnd={hideHandlers} draggable>
                                                                <img draggable={false} src={formItem.icon} height={30} />
                                                                <p draggable={false} className="mt-2 text-semibold color-gray-3">{checkTranslation(formItem.label)}</p>
                                                            </div>
                                                        </div>
                                                    );
                                            }
                                        }
                                        else {
                                            if (formItem.parent === group.key)
                                                return (
                                                    <div className=" p-1 mb-0" style={{ width: '50%' }} key={formItem.type}>
                                                        <div key={index} className="form-item flexcc flex-column text-smaller pt-2 pb-2" onDragStart={(e) => this.onDragStart(e, index, formItem.type)} onDragEnd={hideHandlers} draggable >
                                                            <img draggable={false} src={formItem.icon} height={30} />
                                                            <p draggable={false} className="mt-2 text-semibold color-gray-3">{checkTranslation(formItem.label)}</p>
                                                        </div>
                                                    </div>
                                                );
                                        }
                                    })}
                                </div>
                            </div >
                        )
                    }
                })}
            </div >
        );
    }
}



export default ExistingQuestion;